import i18next from "i18next";
var languages = ["pt", "pt-br", "en-us", "en"];
var setLanguage = function (language) {
    if (!languages.includes(language)) {
        throw new Error("Language not supported");
    }
    i18next.changeLanguage(language);
};
export default setLanguage;
